import { Controller } from "stimulus";
export default class extends Controller {
  static targets = [
    "select",
    "fullImage",
    "singleImage",
    "categoryListings",
    "collectionsListingsField",
    "categoriesListingsField",
    "singleListing",
    "shared",
    "blockSettings",
    "sharedTitles",
    "smallImage",
    "bigImage",
    "backgroundImage",
    "textBlock",
    "videoBlock",
    "countdownBlock",
    "mapBlock",
    "contactFormBlock",
    "socialIconsBlock",
    "resourcePreviewBlock",
    "imageGalleryBlock",
    "collapsibleBlock",
    "imageSliderBlock",
    "categoriesSliderBlock",
    "menuBlock",
    "actions"
  ];

  toggle() {
    if (this.selectTarget.value === "full image") {
      this.hideEverything();

      this.show(this.fullImageTarget);
      this.show(this.actionsTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.textBlockTarget);
      this.show(this.blockSettingsTarget);
    } else if (this.selectTarget.value === "single image") {
      this.hideEverything();

      this.show(this.singleImageTarget);
      this.show(this.actionsTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
    } else if (this.selectTarget.value === "category listings") {
      this.hideEverything();

      this.show(this.categoryListingsTarget);
      this.show(this.categoriesListingsFieldTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value === "collection listings") {
      this.hideEverything();

      this.show(this.categoryListingsTarget);
      this.show(this.collectionsListingsFieldTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value === "featured listings") {
      this.hideEverything();

      this.show(this.categoryListingsTarget);
      this.show(this.collectionsListingsFieldTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } 
    else if (this.selectTarget.value === "single listing") {
      this.hideEverything();

      this.show(this.singleListingTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'general block') {
      this.hideEverything();

      this.show(this.actionsTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.backgroundImageTarget);
      this.show(this.blockSettingsTarget);
    } else if (this.selectTarget.value == 'text block') {
      this.hideEverything();

      this.show(this.textBlockTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'text image combo') {
      this.hideEverything();

      this.show(this.sharedTitlesTarget);
      this.show(this.textBlockTarget);
      this.show(this.singleImageTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'video block') {
      this.hideEverything();

      this.show(this.videoBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'countdown') {
      this.hideEverything();

      this.show(this.countdownBlockTarget);
      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'map'){
      this.hideEverything();

      this.show(this.mapBlockTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'contact form') {
      this.hideEverything()

      this.show(this.contactFormBlockTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'social icons') {
      this.hideEverything()

      this.show(this.socialIconsBlockTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'resource preview block') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.resourcePreviewBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'user reviews') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'image gallery') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.imageGalleryBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'image gallery preview') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.imageGalleryBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'collapsible') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.collapsibleBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'image slider') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.imageSliderBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else if (this.selectTarget.value == 'categories slider') {
      this.hideEverything()

      this.show(this.sharedTitlesTarget);
      this.show(this.categoriesSliderBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);

    } else if (this.selectTarget.value == 'menu') {
      this.hideEverything()
      
      this.show(this.menuBlockTarget);
      this.show(this.blockSettingsTarget);
      this.show(this.actionsTarget);
    } else {
      this.hideEverything()
    }
  }
  showBigImage() {
    if (this.hasSmallImageTarget && this.smallImageTarget.length == 0) {
      this.bigImageTarget.classList.remove("big-device")
    }
  }
  hide(element) {
    element.classList.add('hidden')
  }
  show(element) {
    element.classList.remove('hidden')
  }
  hideEverything() {
    const excludedTargets = ["shared", "select"]; // Targets to exclude
    const hiddenClass = "hidden"; // Class to add

    this.constructor.targets
      .filter((targetName) => !excludedTargets.includes(targetName))
      .forEach((targetName) => {
        const elements = this[`${targetName}Targets`];
        elements.forEach((element) => {
          if (!element.classList.contains(hiddenClass)) {
            element.classList.add(hiddenClass);
          }
        });
      });
  }
  connect() { 
    this.toggle()
    this.showBigImage()
  }
}
